<template>
  <div v-if="allowEditUsers">
    <v-card
      id="history-search"
      class="mx-auto mb-5 secondary rounded-0"
      elevation="0"
    >
      <CardHeader
        title="ANDRE BRUGERE"
        :icon="addUserIcon"
        @iconClicked="
          (user = {
            id: -1,
            user_name: '',
            first_name: '',
            last_name: '',
            email: '',
            phone: ''
          }),
            (displayUser = true)
        "
      />
      <v-data-table
        :headers="headers"
        :items="users"
        :items-per-page="this.$vuetify.breakpoint.smAndDown ? 1 : 10"
        :page.sync="page"
        @page-count="pageCount = $event"
        hide-default-footer
        class="secondary accent--hover"
        dense
        :loading="loading"
        loading-text="Henter brugere"
        no-data-text="Ingen burgere"
      >
        <template v-slot:item.editUser="{ item }">
          <!-- ignore eslint error regarding v-slot directive!!! -->
          <v-icon
            color="primary"
            style="cursor:pointer;"
            @click="(user = item), (displayUser = true)"
          >
            {{ editUserIcon }}
          </v-icon>
        </template>
        <template v-slot:item.changePassword="{ item }">
          <!-- ignore eslint error regarding v-slot directive!!! -->
          <v-icon
            color="primary"
            style="cursor:pointer;"
            @click="(user = item), (displayChangePassword = true)"
          >
            {{ passwordIcon }}
          </v-icon>
        </template>
        <template v-slot:item.deleteUser="{ item }">
          <!-- ignore eslint error regarding v-slot directive!!! -->
          <v-icon
            color="primary"
            style="cursor:pointer;"
            @click="
              (user = item),
                (deleteUserQuestion =
                  'Vil du slette ' +
                  item.first_name +
                  ' ' +
                  item.last_name +
                  '?'),
                (displayPromptDeleteUser = true)
            "
          >
            {{ deleteUserIcon }}
          </v-icon>
        </template>
      </v-data-table>
      <div class="text-center pt-2">
        <v-pagination v-model="page" :length="pageCount"> </v-pagination>
      </div>
    </v-card>
    <ChangePasswordDialog
      :display="displayChangePassword"
      :user="user"
      @disposeDialog="(displayChangePassword = false), (user = {}), loadUsers()"
    />
    <UserDialog
      :display="displayUser"
      :user="user"
      @disposeDialog="(displayUser = false), (user = {}), loadUsers()"
    />
    <PromptDeleteUserDialog
      :display="displayPromptDeleteUser"
      title="Slet bruger?"
      :question="deleteUserQuestion"
      @accepted="
        deleteUser(user),
          (deleteUserAccepted = false),
          (displayPromptDeleteUser = false),
          (deleteUserQuestion = 'Vil du slette bruger?'),
          (user = {})
      "
      @rejected="
        (deleteUserAccepted = false),
          (displayPromptDeleteUser = false),
          (deleteUserQuestion = 'Vil du slette bruger?'),
          (user = {})
      "
    />
  </div>
</template>

<script>
import { dictionary } from "../helpers";
import ChangePasswordDialog from "@/components/dialogs/ChangePasswordDialog.vue";
import UserDialog from "@/components/dialogs/UserDialog.vue";
import CardHeader from "@/components/templates/CardHeader.vue";
import PromptDeleteUserDialog from "@/components/dialogs/QuestionDialog.vue";

export default {
  name: "Users",

  components: {
    ChangePasswordDialog,
    UserDialog,
    CardHeader,
    PromptDeleteUserDialog
  },
  created() {
    this.allowEditUsers = this.$store.getters["user/allowEditUsers"];

    this.loadUsers();
  },
  data() {
    return {
      allowEditUsers: true,
      addUserIcon: dictionary.mdi.user.add,
      editUserIcon: dictionary.mdi.user.edit,
      deleteUserIcon: dictionary.mdi.user.delete,
      passwordIcon: dictionary.mdi.user.password,
      page: 1,
      pageCount: 0,
      headers: [
        { text: "Fornavn", value: "first_name", width: "25%" },
        { text: "Efternavn", value: "last_name", width: "25%" },
        { text: "E-mail", value: "email", width: "25%" },
        { text: "Telefon", value: "phone", width: "10%" },
        { text: "", value: "editUser", width: "5%", sortable: false },
        { text: "", value: "changePassword", width: "5%", sortable: false },
        { text: "", value: "deleteUser", width: "5%", sortable: false }
      ],
      displayChangePassword: false,
      displayUser: false,
      users: [],
      loading: false,
      user: {},
      displayPromptDeleteUser: false,
      deleteUserQuestion: "Vil du slette bruger?"
    };
  },
  methods: {
    async deleteUser(user) {
      await this.$store.dispatch("user/deleteUser", { user });
      this.loadUsers();
    },
    async loadUsers() {
      this.loading = true;
      await this.$store.dispatch("user/loadUsers").then(
        response => {
          this.users = response;
        },
        error => {
          console.error(error);
        }
      );
      this.loading = false;
    }
  }
};
</script>
